module.exports = __webpack_public_path__ + "img/一龙九龟.3a0a0344.jpg";